import * as React from 'react';
import { roundNumber } from '../../lib/number';

function cssNum(n: number): string {
  return (Number(roundNumber(n, 1))).toString();
}

/* tslint:disable:no-string-literal */
function data_listing(
    name: string,
    valueText: string,
    color: string | null,
    level?: number): JSX.Element[] {
  const style: {[key: string]: string} = {float: 'left'};
  if (color) { style['background'] = color; }
  style['paddingLeft'] = cssNum((level || 0) * 2) + 'em';
  return [
    (
      <td key="first" className="first" style={style}>
        {name}
      </td>
    ), (
      <td key="second" className="second">
        {valueText}
      </td>
    )
  ];
}

export function bar_graph(
    name: string,
    valueText: string,
    width: number,
    color: string | null,
    level?: number): JSX.Element {
  const style: {[key: string]: string} = {float: 'left'};
  if (color) { style['background'] = color; }
  style['width'] = cssNum(width / 10) + 'em';
  return (
    <tr key={name}>
      {data_listing(name, valueText, color, level)}
      <td key="third" className="bar">
        <div style={style}>&nbsp;</div>
      </td>
    </tr>
  );
}
/* tslint:enable:no-string-literal */



// WEBPACK FOOTER //
// ./src/feature/graphs/Bar.tsx